import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {Title1} from '../../../../components/Typography';
import {Element} from 'react-scroll';
import CartMenuSidebarContainer from '../../../CartMenuSidebar/CartMenuSidebarContainer';
import GroupedMenu from './components/GroupedMenu';
import EmptyState from './components/EmptyState';

const Wrapper = styled(Element)`
  display: grid;
  grid-gap: 40px;
  padding-bottom: ${props => (props.categoryId == 999 ? '0' : '64px')};
  @media (max-width: 786px) {
    padding-bottom: ${props => (props.categoryId == 999 ? '0' : '28px')};
  }
`;

const CategoryName = styled(Title1)`
  margin-top: ${props => (props.isOffersEnabled ? '0' : '20px')};
  width: fit-content;
  font-weight: 600;
  margin-bottom: 20px;

  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    padding-top: 2px;
    border-bottom: ${props => props.categoriesBarSelectedBorderColorWidth} solid
      ${props => props.theme.categoriesBarSelectedBorderColor};
  }
`;

const ProductCartWrapper = styled.div`
  display: grid;

  grid-template-columns: 1fr 264px;
  grid-gap: 32px;
  margin: 0 5% 0 5%;
  height: 100%;
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 786px) {
    margin-top: -50px;
    display: block;
    margin-top: 12px;
  }
`;

const ProductDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    margin-top: 10px;
  }
`;

function GlobalSearchMenu({
  query,
  hits,
  refine,
  cart,
  locations,
  products,
  emptyCart,
  specialHours,
  selectedLocation,
  getProductToConfigure,
  updateInterOrderType,
  handleComboPreviewClick,
  updateOrderSettingModalIsVisible,
  changePickUpLocationFromLocationsPage,
  requestingGetMenu,
  orderSettingModalIsVisible,
  updateOrderType,
  productCustomizerReducer,
  updateSelectedLocation,
  orderSettingReducer,
}) {
  const [locationsToShow, setLocationsToShow] = useState([]);

  useEffect(() => {
    updateLocationsToShow();
  }, [hits, query]);

  const updateLocationsToShow = () => {
    const locationsArray = [];

    if (query === '') {
      setLocationsToShow([]);
      return;
    }

    hits.map(hit => {
      if (!locationsArray.includes(hit.business_name)) {
        locationsArray.push(hit.business_name);
      }
    });

    const locationsSet = new Set(locationsArray);
    setLocationsToShow([...locationsSet]);
  };

  return (
    <ProductCartWrapper>
      <div>
        <CategoryName>"{query}"</CategoryName>
        {hits.length > 0 ? (
          locations.map(location => (
            <div>
              {locationsToShow.filter(loc =>
                loc.includes(location.name.split(' ')[0])
              ).length > 0 ? (
                <GroupedMenu
                  key={location}
                  hits={hits}
                  refine={refine}
                  cart={cart}
                  location={location}
                  locations={locations}
                  emptyCart={emptyCart}
                  specialHours={specialHours}
                  selectedLocation={selectedLocation}
                  updateInterOrderType={updateInterOrderType}
                  getProductToConfigure={getProductToConfigure}
                  updateOrderSettingModalIsVisible={
                    updateOrderSettingModalIsVisible
                  }
                  changePickUpLocationFromLocationsPage={
                    changePickUpLocationFromLocationsPage
                  }
                  handleComboPreviewClick={handleComboPreviewClick}
                  orderSettingModalIsVisible={orderSettingModalIsVisible}
                  menuProducts={products}
                  updateOrderType={updateOrderType}
                  productCustomizerReducer={productCustomizerReducer}
                  updateSelectedLocation={updateSelectedLocation}
                  orderSettingReducer={orderSettingReducer}
                />
              ) : null}
            </div>
          ))
        ) : (
          <EmptyState />
        )}
      </div>
      <CartMenuSidebarContainer />
    </ProductCartWrapper>
  );
}

export default GlobalSearchMenu;
